import { styled } from '../../system';
export const Text = styled('span', {
    fontFamily: '$sans',
    variants: {
        variant: {
            display2Xl: {
                textDisplay2Xl: true
            },
            displayXl: {
                textDisplayXl: true
            },
            displayLg: {
                textDisplayLg: true
            },
            displayMd: {
                textDisplayMd: true
            },
            displaySm: {
                textDisplaySm: true
            },
            displayXs: {
                textDisplayXs: true
            },
            xl: {
                textXl: true
            },
            lg: {
                textLg: true
            },
            md: {
                textMd: true
            },
            sm: {
                textSm: true
            },
            xs: {
                textXs: true
            }
        },
        weight: {
            regular: {
                fontWeight: '$regular'
            },
            medium: {
                fontWeight: '$medium'
            },
            semibold: {
                fontWeight: '$semibold'
            },
            bold: {
                fontWeight: '$bold'
            }
        }
    },
    defaultVariants: {
        variant: 'sm',
        weight: 'regular'
    }
});
Text.displayName = 'Text';
